import React from "react";
import { Field, Form } from "react-final-form";
import { submit, validate } from "./EditServiceValuationServiceFormSubmit";
import BMXTextField from "../../../../../../Components/Inputs/BMXTextField/BMXTextField";
import { Col, Row } from "react-bootstrap";
import { t } from "i18next";
import BMXButton from "../../../../../../Components/Buttons/BMXButton/BMXButton";
import { Icon, IconButton } from "@mui/material";



const EditServiceValuationServiceForm = (props) => {
  const { initialValues, handleHide } = props;

  const modifyLaborHours =(type,form)=>{
    if(type === "decrease"){
      const tmp = Number(form.getState()?.values?.laborHours || 0) - 0.5;
      form?.change("laborHours", tmp<=0? 0 : tmp);
      return;
    }
    form?.change("laborHours", Number(form.getState()?.values?.laborHours || 0) + 0.5);
  }

  return (
    <Form
      initialValues={{
        ...initialValues,
      }}
      onSubmit={(val) => submit(val, props)}
      validate={validate}
    >
      {({ handleSubmit,form }) => (
        <form onSubmit={handleSubmit} className="EditServiceValuationServiceForm">
          <Row>
            <Col xs={6}>
              <Field
                type="money"
                name="hourlyRate"
                decimalScale={2}
                component={BMXTextField}
                label={t("global:editServiceValuationServiceForm.hourlyRate")}
              />
            </Col>
            <Col xs={{span:6}}>
              <div className="d-flex align-items-normal gap-1">
                <IconButton onClick={()=>modifyLaborHours("decrease",form)} style={{height:"max-content", margin:'auto 0'}} size="small">
                  <Icon >
                  remove
                  </Icon>
                </IconButton>
                <Field
                  type="number"
                  name="laborHours"
                  readOnly={true}
                  component={BMXTextField}
                  label={t("global:editServiceValuationServiceForm.laborHours")}
                />
                <IconButton  onClick={()=>modifyLaborHours("increase",form)} style={{height:"max-content", margin:'auto 0'}} size="small">
                  <Icon>
                    add
                  </Icon>
                </IconButton>
              </div>
            </Col>
          </Row>
          <Row className=" d-flex justify-content-end">
            <Col className="mt-3 d-flex gap-3 justify-content-end">
              <BMXButton
                data-cy="submit"
                type="button"
                onClick={handleHide}
              >
                {t("global:close")}
              </BMXButton>
              <BMXButton
                data-cy="submit"
                bmxclass="Success"
                type="Submit"
                onClick={handleSubmit}
              >
                {t("global:add")}
              </BMXButton>
            </Col>
          </Row>
        </form>
      )}
    </Form>
  );
};

export default EditServiceValuationServiceForm;
